import { render, staticRenderFns } from "./ApplicantPanelV2026.vue?vue&type=template&id=ec754920&scoped=true"
import script from "./ApplicantPanelV2026.vue?vue&type=script&lang=js"
export * from "./ApplicantPanelV2026.vue?vue&type=script&lang=js"
import style0 from "./ApplicantPanelV2026.vue?vue&type=style&index=0&id=ec754920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec754920",
  null
  
)

export default component.exports